import {Text} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Offer} from '../types';

// Every column is sortable (MODULE_COMPLIANCE_CHECKLIST §3a). The accessor is
// what useTableSort sorts by; render only controls how the cell looks.
export const useOffersTableColumns = (onRecordClick: (record: Offer) => void): DataTableColumn<Offer>[] => [
    {
        accessor: 'name',
        title: I18n.get('Name'),
        sortable: true,
        render: (item) => (
            <Text
                c="blue"
                style={{cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.name}
            </Text>
        ),
    },
    {
        accessor: 'url',
        title: I18n.get('URL'),
        sortable: true,
    },
    {
        accessor: 'phone',
        title: I18n.get('Phone'),
        sortable: true,
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        sortable: true,
        render: (item) => formatTimestamp(item.created),
    },
];
